import React from 'react'
import styled from 'styled-components'
import { styleUtils } from 'styles'

const Root = styled.div`
  background-color: ${({ $color, theme }) =>
    styleUtils.colors.fade(theme.colors[$color], 0.08)};
  border-radius: 0 ${({ theme }) => theme.radii[1]}
    ${({ theme }) => theme.radii[1]} 0;
  border-left: 0.25rem solid ${({ $color, theme }) => theme.colors[$color]};
`

export const Note = ({ children, color }) => (
  <Root $color={color}>{children}</Root>
)

Note.defaultProps = {
  color: 'primary',
}
